import { z } from 'zod'

export enum DocumentFileFormat {
  PDF = 'pdf',
  Image = 'image',
}

export const documentViewerSearchParams = z.object({
  id: z.string(),
  filename: z.string(),
  title: z.string().optional(),
  fileFormat: z.enum(DocumentFileFormat).optional(),
  temporaryPreviewUrl: z.string().optional(),
  pageRotations: z
    .preprocess((v) => {
      if (!v) return undefined
      if (typeof v === 'object') return v
      try {
        return JSON.parse(v as string)
      } catch {
        return undefined
      }
    }, z.record(z.string(), z.number()).optional())
    .optional(),
})
